import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

// The title page is light; the game (three.js and the compound) only downloads when someone presses play.
const CapGunHome = lazy(() => import("./capgun/Home"));
const CapGunPage = lazy(() => import("./capgun/CapGunPage"));

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/capgun/play" element={<Suspense fallback={null}><CapGunPage /></Suspense>} />
        <Route path="/play" element={<Navigate to="/capgun/play" replace />} />
        <Route path="*" element={<Suspense fallback={null}><CapGunHome /></Suspense>} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
